import React, { Component } from 'react';
import { Field, reduxForm } from 'redux-form';
import submit from './submit';
import validate from './validate';
import cx from 'classnames';
import {
    Button,
    FormGroup,
    Col,
    FormControl,
    Panel,
    Grid,
    Row
} from 'react-bootstrap';
import withStyles from 'isomorphic-style-loader/withStyles';
import { FormattedMessage, injectIntl } from 'react-intl';

import Image from './Image/Image';
import InputFieldComponent from '../../../Common/FormField/InputFieldComponent';

import messages from '../../../../locale/messages';

import s from './WhyHostFormBlock3.css';
import bt from '../../../../components/commonStyle.css';
class WhyHostFormBlock3 extends Component {

    render() {

        const { error, handleSubmit, submitting, dispatch, initialValues } = this.props;
        const { formatMessage } = this.props.intl;

        return (
            <Grid fluid>
                <Row>
                    <Col lg={12} md={12} sm={12} xs={12}>
                        <h1 className={s.siteAdminHeading}><FormattedMessage {...messages.whyBecomeHostBlock3} /></h1>
                    </Col>
                    <Col xs={12} sm={12} md={9} lg={8} className={s.blockCenter}>
                        <Panel className={cx(s.panelHeader)}>
                            <form onSubmit={handleSubmit(submit)}>
                                {error && <strong>{formatMessage(error)}</strong>}
                                <FormGroup className={bt.space4}>
                                    <label className={s.labelTextNew} ><FormattedMessage {...messages.coverSectionBannerLabel} /></label>
                                    <Image />
                                </FormGroup>
                                <Field
                                    name="coverSectionTitle1"
                                    type="text"
                                    component={InputFieldComponent}
                                    placeholder={formatMessage(messages.coverSectionTitlePlaceHolder)}
                                    label={formatMessage(messages.coverSectionTitleLabel)}
                                    labelNumber={'1'}
                                    inputClass={bt.commonControlInput}
                                    formGroupClass={bt.space4}
                                />
                                <Field
                                    name="coverSectionContent1"
                                    component={InputFieldComponent}
                                    placeholder={formatMessage(messages.coverSectionContentPlaceHolder)}
                                    label={formatMessage(messages.coverSectionContentLabel)}
                                    labelNumber={'1'}
                                    componentClass={'textarea'}
                                    inputClass={bt.commonControlTextArea}
                                    formGroupClass={bt.space4}
                                />
                                <Field
                                    name="coverSectionFeature1"
                                    component={InputFieldComponent}
                                    label={formatMessage(messages.coverSectionFeatureLabel)}
                                    labelNumber={'1'}
                                    componentClass={'textarea'}
                                    inputClass={bt.commonControlTextArea}
                                    formGroupClass={bt.space4}
                                    placeholder={formatMessage(messages.coverSectionFeaturePlaceHolder)}
                                />
                                <Field
                                    name="coverSectionFeature2"
                                    component={InputFieldComponent}
                                    label={formatMessage(messages.coverSectionFeatureLabel)}
                                    labelNumber={'2'}
                                    componentClass={'textarea'}
                                    inputClass={bt.commonControlTextArea}
                                    formGroupClass={bt.space4}
                                    placeholder={formatMessage(messages.coverSectionFeaturePlaceHolder)}
                                />
                                <Field
                                    name="coverSectionFeature3"
                                    component={InputFieldComponent}
                                    label={formatMessage(messages.coverSectionFeatureLabel)}
                                    labelNumber={'3'}
                                    componentClass={'textarea'}
                                    inputClass={bt.commonControlTextArea}
                                    formGroupClass={bt.space4}
                                    placeholder={formatMessage(messages.coverSectionFeaturePlaceHolder)}
                                />
                                <Field
                                    name="coverSectionFeature4"
                                    component={InputFieldComponent}
                                    label={formatMessage(messages.coverSectionFeatureLabel)}
                                    labelNumber={'4'}
                                    componentClass={'textarea'}
                                    inputClass={bt.commonControlTextArea}
                                    formGroupClass={bt.space4}
                                    placeholder={formatMessage(messages.coverSectionFeaturePlaceHolder)}
                                />
                                <Field
                                    name="coverSectionFeature5"
                                    component={InputFieldComponent}
                                    label={formatMessage(messages.coverSectionFeatureLabel)}
                                    labelNumber={'5'}
                                    componentClass={'textarea'}
                                    inputClass={bt.commonControlTextArea}
                                    formGroupClass={bt.space4}
                                    placeholder={formatMessage(messages.coverSectionFeaturePlaceHolder)}
                                />
                                <Field
                                    name="coverSectionFeature6"
                                    component={InputFieldComponent}
                                    label={formatMessage(messages.coverSectionFeatureLabel)}
                                    labelNumber={'6'}
                                    componentClass={'textarea'}
                                    inputClass={bt.commonControlTextArea}
                                    formGroupClass={bt.space4}
                                    placeholder={formatMessage(messages.coverSectionFeaturePlaceHolder)}
                                />

                                <div className='singleButtonFlexEnd'>
                                    <Button className={cx(bt.btnPrimary, bt.btnLarge)} type="submit" disabled={submitting}>
                                        <FormattedMessage {...messages.save} />
                                    </Button>
                                </div>
                            </form>
                        </Panel>
                    </Col>
                </Row>
            </Grid>
        );
    }

}

WhyHostFormBlock3 = reduxForm({
    form: 'WhyHostForm',
    validate
})(WhyHostFormBlock3);

export default injectIntl(withStyles(s, bt)(WhyHostFormBlock3));